// @flow

// - Stylesheet
import './loading.less';

// - Vendors
import { View } from '@insolus/backbone';

class LoadingView extends View {
    // eslint-disable-next-line global-require
    get template(): Function { return require('./loading.hbs'); }

    initialize() {
        this.render();
    }
}

export default LoadingView;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/loading/loading.js